import React from "react"
import camelCase from "lodash/camelCase"

import ActionCallForm from "./ActionCallForm"
import { Element, Image, Text } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import { Maybe } from "types/Maybe"

import { ActionCallType } from "types/shared-components"

type HardCodedType = {
  primary: {
    cta_intro: string
    formAdditionalRequestBody: string
    formInputType: string
    formName: string
  }
}

type OwnProps = {
  data: Maybe<ActionCallType> | HardCodedType
}

export type ActionCallProps = OwnProps

const ActionForm: React.FC<ActionCallProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data?.primary) return null
  const { primary } = data

  const {
    cta_background_color,
    cta_button_text,
    cta_eyebrow,
    form_confirmation_text,
    form_error_text,
    formHiddenFields,
    cta_input_placeholder,
    formInputType,
    formName,
    form_input_type,
    form_name,
    image,
    cta_intro,
    title1,
  } = primary

  const bgColor = camelCase(cta_background_color)

  return (
    <Element bg={bgColor}>
      <Grid gridTemplateColumns="1col">
        <Element
          color="navy"
          gridColumnEnd="12"
          gridColumnStart="2"
          pb={["45", "80"]}
          pt={["45", "80"]}
          textAlign="center"
        >
          {image && <Image mb="75" display="block" imageData={image} />}
          {cta_eyebrow && (
            <Text
              as="h1"
              fontSize={["13", "text.captionCaps"]}
              lineHeight={["22px", "1.8"]}
              mb={["20"]}
              variant="captionCaps"
            >
              {cta_eyebrow}
            </Text>
          )}
          {title1?.text && (
            <Text
              as="h2"
              fontSize={["36", "text.headerExtraLarge"]}
              lineHeight={["44px", "1.37"]}
              mb={["20", "35"]}
              mx="auto"
              variant="header"
            >
              {title1.text}
            </Text>
          )}
          {cta_intro && (
            <Text
              as="h6"
              fontSize={["17", "text.body"]}
              lineHeight={["28px", "1.8"]}
              m={["0 auto", "0 auto"]}
            >
              {cta_intro}
            </Text>
          )}
          <ActionCallForm
            bgInput={bgColor}
            buttonText={cta_button_text}
            formConfirmationText={form_confirmation_text}
            formErrorText={form_error_text}
            formHiddenFields={formHiddenFields}
            formInputPlaceholder={cta_input_placeholder}
            formInputType={formInputType || form_input_type}
            formName={formName || form_name}
          />
        </Element>
      </Grid>
    </Element>
  )
}

export default ActionForm
